/*! quiz.js
    v0.2 cleaned and fixed
    based on original by Mircea Piturca
    MIT License
*/
(function Quiz() {
  'use strict';

    /* #14agency start: Quiz Super Debug */
  var DEBUG_QUIZ = true;

  function debugLog(label, data) {
    if (!DEBUG_QUIZ) return;
    console.log('[QUIZ DEBUG] ' + label, data);
  }

  function debugGroup(label, fn) {
    if (!DEBUG_QUIZ) {
      fn();
      return;
    }

    console.group('[QUIZ DEBUG] ' + label);
    try {
      fn();
    } finally {
      console.groupEnd();
    }
  }

  function debugSafeProduct(product) {
    if (!product) return null;

    return {
      title: product.title,
      url: product.url,
      available: product.available,
      price: product.price,
      type: product.type,
      tags: product.tags,
      vendor: product.vendor,
      options: product.options,
      metafields: product.metafields
    };
  }

  function debugNormalizeArray(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'undefined' || value === null) return [];
    return [value];
  }

  function debugInspectFilter(filter, product) {
    var args = filter.args || [];
    var result = {
      type: filter.type,
      args: args,
      passed: false,
      actual: null
    };

    if (filter.type === 'tag') {
      result.actual = product.tags || [];
      result.passed = contains(args, result.actual);
      return result;
    }

    if (filter.type === 'type') {
      result.actual = product.type || [];
      result.passed = contains(args, result.actual);
      return result;
    }

    if (filter.type === 'vendor') {
      result.actual = debugNormalizeArray(product.vendor);
      result.passed = contains(args, result.actual);
      return result;
    }

    if (filter.type === 'price') {
      result.actual = Number(product.price);
      result.operator = last(args);
      result.expected = Number(head(args));
      result.passed = numberComparison(result.operator, result.actual, result.expected);
      return result;
    }

    if (filter.type === 'option') {
      var filterName = String(head(args) || '').toLowerCase();
      var filterValues = (last(args) || []).map(function(v) {
        return String(v).toLowerCase().trim();
      });

      result.actual = (product.options || []).map(function(option) {
        return {
          name: option.name,
          values: option.values
        };
      });

      result.passed = (product.options || []).some(function(option) {
        var optionName = String(option.name || '').toLowerCase();
        var optionValues = (option.values || []).map(function(v) {
          return String(v).toLowerCase().trim();
        });

        return equals(optionName, filterName) && contains(optionValues, filterValues);
      });

      return result;
    }

    if (filter.type === 'metafield') {
      var metafieldKey = head(args);
      var allowedValues = last(args);
      var productValue = product.metafields ? product.metafields[metafieldKey] : undefined;

      result.key = metafieldKey;
      result.actual = productValue;
      result.actualString = typeof productValue === 'undefined' ? null : JSON.stringify(productValue).toLowerCase();

      if (!product.metafields || typeof product.metafields[metafieldKey] === 'undefined') {
        result.passed = false;
        return result;
      }

      if (isEmpty(allowedValues)) {
        result.passed = true;
        return result;
      }

      result.passed = allowedValues.some(function(allowedValue) {
        return result.actualString.indexOf(String(allowedValue).toLowerCase().trim()) !== -1;
      });

      return result;
    }

    return result;
  }

  function debugRenderResults(payload) {
    if (!DEBUG_QUIZ || !nodes || !nodes.panels || !nodes.panels.length) return payload;

    var resultsPanel = last(nodes.panels);
    if (!resultsPanel) return payload;

    var output = resultsPanel.querySelector('[data-quiz-debug-output]');
    if (!output) return payload;

    output.textContent = JSON.stringify(payload, null, 2);
    return payload;
  }
  /* #14agency end: Quiz Super Debug */

  var support = getSupport();
  var configNode = document.querySelector('[data-quiz-config]');
  if (!configNode) return;

  var config = JSON.parse(configNode.innerHTML);
  var filtersData = Object.freeze(objMap(validate, config.filters || {}));
  var productData = Object.freeze(config.products || []);
  var nodes;
  var publicAPI;

  compose(themeEditor, init)();

  function init() {
    nodes = {
      doc: [document],
      track: head(nodeList('.quiz-track')),
      panels: nodeList('.quiz-panel'),
      answers: nodeList('[data-answer-trigger]'),
      controls: nodeList('[data-quiz-index]'),
      showResults: nodeList('[data-show-results]')
    };

    if (!nodes.track || !nodes.panels.length) return;

    nodes.answers.map(
      partial(
        addEvent,
        'change',
        compose(UIheroUpdate, value, target)
      )
    );

        /* #14agency start: Quiz Super Debug */
    nodes.showResults.map(
      partial(
        addEvent,
        'click',
        onShowResultsClick
      )
    );
    /* #14agency end: Quiz Super Debug */

    nodes.controls.map(
      partial(
        addEvent,
        'click',
        compose(UIgoTo, UIdirection, target, preventDefault)
      )
    );

    nodes.doc.map(
      partial(
        addEvent,
        'quiz-question-change',
        compose(UIloadImages, UIgetImages, UIupdateHash, UIhideResults, id, target)
      )
    );

    if (support.IntersectionObserver) {
      initIntersectionObserver(nodes.track, nodes.panels, scrollEndCallback);
    } else {
      initScrollObserver(nodes.track, scrollEndCallback);
    }
  }

  publicAPI = {
    goTo: UIgoTo,
    next: UInext,
    prev: UIprev,
    index: UIindex,
    nodes: function() { return nodes; },
    products: productData,
    filters: filtersData
  };

  window.SectionsDesign = window.SectionsDesign || {};
  window.SectionsDesign.Quiz = publicAPI;

  return publicAPI;

    /* #14agency start: Quiz Super Debug */
  function onShowResultsClick(evt) {
    preventDefault(evt);

    var answers = selectedAnswers();
    var filters = selectedFilters(answers);
    var products = filterProducts(filters);

    debugGroup('show results click', function() {
      debugLog('selected answers', answers);
      debugLog('selected filters', filters);
      debugLog('matched products', products.map(debugSafeProduct));
    });

    debugRenderResults({
      selectedAnswers: answers,
      selectedFilters: filters,
      matchedProducts: products.map(debugSafeProduct)
    });

    UIupdateResults(products);
    UIshowResults(products);

    return products;
  }
  /* #14agency end: Quiz Super Debug */

  /* Selected answers / filters */

  function selectedAnswers() {
    var answers = nodeList('[data-answer-trigger]:checked').map(value);

    /* #14agency start: Quiz Debug */
    debugLog('selectedAnswers()', answers);
    /* #14agency end: Quiz Debug */

    return answers;
  }

  function selectedFilters(ids) {
    var rawFilters = props(ids, filtersData);
    var nonEmptyFilters = rawFilters.filter(not(isEmpty));
    var flatFilters = flatten(nonEmptyFilters);

    /* #14agency start: Quiz Debug */
    debugGroup('selectedFilters()', function() {
      debugLog('ids', ids);
      debugLog('rawFilters', rawFilters);
      debugLog('nonEmptyFilters', nonEmptyFilters);
      debugLog('flatFilters', flatFilters);
    });
    /* #14agency end: Quiz Debug */

    return flatFilters;
  }

  function mapFilters(filters) {
    var fnMap = {
      price: priceFilter,
      tag: tagFilter,
      type: typeFilter,
      vendor: vendorFilter,
      option: optionFilter,
      metafield: metafieldFilter
    };

    var mappedFilters = filters
      .map(function(filter, index) {
        var fn = fnMap[filter.type];

        /* #14agency start: Quiz Debug */
        if (DEBUG_QUIZ) {
          console.log('[QUIZ DEBUG] mapFilters()', {
            index: index,
            filter: filter,
            matchedFunction: !!fn
          });
        }
        /* #14agency end: Quiz Debug */

        return fn ? partial(fn, filter.args) : null;
      })
      .filter(Boolean);

    /* #14agency start: Quiz Debug */
    debugLog('mapFilters() count', mappedFilters.length);
    /* #14agency end: Quiz Debug */

    return mappedFilters;
  }

  function filterProducts(filterFns) {
    var matchedProducts = productData.filter(function(product) {
      var results = filterFns.map(function(fn, index) {
        var passed = fn(product);

        /* #14agency start: Quiz Debug */
        if (DEBUG_QUIZ) {
          console.log('[QUIZ DEBUG] product/filter check', {
            product: product.title,
            filterIndex: index,
            passed: passed,
            productData: {
              type: product.type,
              tags: product.tags,
              vendor: product.vendor,
              options: product.options,
              metafields: product.metafields
            }
          });
        }
        /* #14agency end: Quiz Debug */

        return passed;
      });

      return results.indexOf(false) === -1;
    });

    /* #14agency start: Quiz Debug */
    debugLog(
      'filterProducts() matchedProductsFinal',
      matchedProducts.map(function(product) {
        return product.title;
      })
    );
    /* #14agency end: Quiz Debug */

    return matchedProducts;
  }

  /* UI */

  function UIshowResults(productArr) {
    last(nodes.panels).removeAttribute('hidden');
    return productArr;
  }

  function UIhideResults(panelId) {
    var resultsPanel = last(nodes.panels);
    if (panelId !== id(resultsPanel)) {
      debounce(function() {
        resultsPanel.setAttribute('hidden', true);
      }, 500)();
    }
    return panelId;
  }

  function UIupdateResults(productArr) {
    var html = productArr.reduce(function(acc, product) {
      acc += product.html || '';
      return acc;
    }, '');

    last(nodes.panels).querySelector('.quiz-main').innerHTML = html;
    return productArr;
  }

  function UIheroUpdate(answerId) {
    var index = UIindex();
    var oldImage = document.querySelector('[data-question-index="' + index + '"][data-image-selected]');
    var newImage = document.querySelector('[data-img="' + answerId + '"]');

    if (!newImage) return answerId;

    if (support.CSSAnimation) {
      imageChangeAnimate();
    } else {
      imageChange();
    }

    function imageChangeAnimate() {
      newImage.addEventListener('animationend', imageChange);
      newImage.setAttribute('data-image-animated', true);
      newImage.setAttribute('data-image-selected', true);

      if (oldImage) {
        oldImage.setAttribute('data-image-animated', true);
        oldImage.removeAttribute('data-image-selected');
      }
    }

    function imageChange() {
      newImage.setAttribute('data-image-selected', true);
      newImage.removeAttribute('data-image-animated');
      newImage.removeEventListener('animationend', imageChange);

      if (oldImage) {
        oldImage.removeAttribute('data-image-selected');
        oldImage.removeAttribute('data-image-animated');
      }
    }

    return answerId;
  }

  function UIindex() {
    var index = Math.round(nodes.track.scrollLeft / nodes.track.getBoundingClientRect().width);
    return clamp(index, 0, nodes.panels.length);
  }

  function UIdirection(element) {
    return Number(attr('data-quiz-index', element));
  }

  function UIgoTo(index) {
    var track = nodes.track;
    var panel = head(nodes.panels);
    var x = track.getBoundingClientRect().width * index;

    if (support.scrollBehavior || !support.customProperties) {
      nativeScroll();
    } else {
      fallbackScroll();
    }

    function nativeScroll() {
      track.scrollLeft = x;
    }

    function fallbackScroll() {
      track.style.setProperty('--scroll-x', (track.scrollLeft - x) + 'px');
      track.setAttribute('data-scroll-animation', true);
      panel.addEventListener('animationend', endAnimation);
    }

    function endAnimation() {
      panel.removeEventListener('animationend', endAnimation);
      track.removeAttribute('data-scroll-animation');
      nativeScroll();
    }

    return index;
  }

  function UInext() {
    var index = UIindex();
    var nextIndex = clamp(index + 1, 0, nodes.panels.length);
    return UIgoTo(nextIndex);
  }

  function UIprev() {
    var index = UIindex();
    var prevIndex = clamp(index - 1, 0, nodes.panels.length);
    return UIgoTo(prevIndex);
  }

  function UIupdateHash(panelId) {
    var newHash = '#' + panelId;
    var oldHash = window.location.hash;
    var shouldUpdate = not(equals)(newHash, oldHash);

    if (support.pushState && shouldUpdate) {
      history.replaceState(null, null, newHash);
    }

    return panelId;
  }

  function UIgetImages(panelId) {
    return nodeList('#' + panelId + ' [data-img]');
  }

  function UIloadImages(imagesArr) {
    var changeSrcset = partial(attrTransfer, 'data-lazy-srcset', 'srcset');
    var changeSrc = partial(attrTransfer, 'data-lazy-src', 'src');

    imagesArr.map(changeSrcset).map(changeSrc);
    return imagesArr;
  }

  /* Scroll */

  function scrollEndCallback(entries) {
    if (support.IntersectionObserver) {
      var inView = entries.filter(function(entry) {
        return entry.intersectionRatio >= 0.5;
      });

      if (inView.length > 0) {
        emitEvent('quiz-question-change', { target: head(inView).target });
      }
    } else {
      emitEvent('quiz-question-change', { target: nodes.panels[UIindex()] });
    }
  }

  function initIntersectionObserver(root, rootNodes, callback) {
    var observer = new IntersectionObserver(callback, {
      root: root,
      threshold: 0.5
    });

    rootNodes.map(function(element) {
      observer.observe(element);
    });

    emitEvent('quiz-question-change', { target: nodes.panels[UIindex()] });
  }

  function initScrollObserver(root, callback) {
    var initScroll = debounce(callback, 160);
    root.addEventListener('scroll', initScroll);
    emitEvent('quiz-question-change', { target: nodes.panels[UIindex()] });
  }

  /* Validation */

  function validate(filters) {
    var fnMap = {
      tag: arrValidation,
      type: arrValidation,
      vendor: arrValidation,
      price: priceValidation,
      option: optionValidation,
      metafield: metafieldValidation
    };

    return (filters || []).filter(function(filter) {
      var validator = fnMap[filter.type];
      return validator ? validator(filter.args) : false;
    });
  }

  function arrValidation(args) {
    return isArray(args);
  }

  function priceValidation(args) {
    return isArray(args) && isNumber(head(args));
  }

  function optionValidation(args) {
    return isArray(args) && isString(head(args)) && isArray(last(args));
  }

  function metafieldValidation(args) {
    return isArray(args) && args.length === 2 && isString(head(args)) && isArray(last(args));
  }

  /* Filters */

  function tagFilter(args, product) {
    return contains(args, product.tags || []);
  }

  function typeFilter(args, product) {
    return contains(args, product.type || []);
  }

  function vendorFilter(args, product) {
    if (isArray(product.vendor)) return contains(args, product.vendor);
    return contains(args, [product.vendor]);
  }

  function priceFilter(args, product) {
    var operator = last(args);
    var n1 = Number(product.price);
    var n2 = Number(head(args));
    return numberComparison(operator, n1, n2);
  }

  function optionFilter(args, product) {
    var filterName = String(head(args) || '').toLowerCase();
    var filterValues = (last(args) || []).map(function(v) {
      return String(v).toLowerCase().trim();
    });

    return (product.options || []).some(function(option) {
      var optionName = String(option.name || '').toLowerCase();
      var optionValues = (option.values || []).map(function(v) {
        return String(v).toLowerCase().trim();
      });

      return equals(optionName, filterName) && contains(optionValues, filterValues);
    });
  }

  function metafieldFilter(args, product) {
    var metafieldKey = head(args);
    var allowedValues = last(args);

    if (!product.metafields || typeof product.metafields[metafieldKey] === 'undefined') {
      return false;
    }

    if (isEmpty(allowedValues)) {
      return true;
    }

    var productValue = product.metafields[metafieldKey];
    var productValueStr = JSON.stringify(productValue).toLowerCase();

    return allowedValues.some(function(allowedValue) {
      return productValueStr.indexOf(String(allowedValue).toLowerCase().trim()) !== -1;
    });
  }

  function numberComparison(operator, n1, n2) {
    if (operator === '=') return n1 === n2;
    if (operator === '<') return n1 < n2;
    if (operator === '>') return n1 > n2;
    if (operator === '<=') return n1 <= n2;
    if (operator === '>=') return n1 >= n2;
    return false;
  }

  /* Events */

  function addEvent(type, fn, element) {
    element.addEventListener(type, fn);
  }

  function createEvent(eventType, data) {
    return new CustomEvent(eventType, { detail: data });
  }

  function emitEvent(eventType, data) {
    document.dispatchEvent(createEvent(eventType, data));
  }

  function preventDefault(evt) {
    evt.preventDefault();
    return evt;
  }

  function target(evt) {
    return evt.detail && evt.detail.target ? evt.detail.target : evt.target;
  }

  /* DOM */

  function id(element) {
    return element.id;
  }

  function attr(str, element) {
    return element.getAttribute(str);
  }

  function value(element) {
    return attr('value', element);
  }

  function nodeList(str, root) {
    if (!root) root = document;
    return Array.prototype.slice.call(root.querySelectorAll(str));
  }

  function attrTransfer(attr1, attr2, element) {
    nodeList('[' + attr1 + ']', element).map(function(el) {
      var newAttr = el.getAttribute(attr1);
      if (newAttr) {
        el.setAttribute(attr2, newAttr);
        el.removeAttribute(attr1);
      }
      return el;
    });
    return element;
  }

  /* Object / primitive helpers */

  function equals(a, b) {
    return a === b;
  }

  function keys(obj) {
    return Object.keys(obj);
  }

  function objMap(fn, obj) {
    return keys(obj).reduce(function(acc, key) {
      acc[key] = fn(obj[key]);
      return acc;
    }, {});
  }

  function isNumber(arg) {
    return !isNaN(Number(arg));
  }

  function isString(arg) {
    return typeof arg === 'string' && arg.length !== 0;
  }

  function clamp(num, min, max) {
    return num <= min ? min : num >= max ? max : num;
  }

  /* Array helpers */

  function isArray(arg) {
    return Array.isArray(arg);
  }

  function isEmpty(array) {
    if (!Array.isArray(array) || array.length === 0) return true;

    return array.every(function(val) {
      return (
        val === null ||
        typeof val === 'undefined' ||
        String(val).trim() === ''
      );
    });
  }

  function contains(arr1, arr2) {
    return arr1.some(function(value) {
      return arr2.indexOf(value) !== -1;
    });
  }

  function flatten(arr) {
    return arr.reduce(function(acc, val) {
      return isArray(val) ? acc.concat(flatten(val)) : acc.concat(val);
    }, []);
  }

  function last(arr) {
    return arr[arr.length - 1];
  }

  function head(arr) {
    return arr[0];
  }

  function props(arr, obj) {
    return arr.reduce(function(acc, val) {
      if (obj && typeof obj[val] !== 'undefined') {
        acc.push(obj[val]);
      }
      return acc;
    }, []);
  }

  /* Functional helpers */

  function not(predicate) {
    return function negated() {
      return !predicate.apply(undefined, arguments);
    };
  }

  function allPass(fns, arg) {
    var predicates = fns.map(function(fn) {
      return fn(arg);
    });
    return predicates.indexOf(false) === -1;
  }

  function debounce(fn, wait, immediate) {
    var timeout;
    return function() {
      var context = this;
      var args = arguments;

      var later = function() {
        timeout = null;
        if (!immediate) fn.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);

      if (callNow) fn.apply(context, args);
    };
  }

  function partial(fn) {
    var slice = Array.prototype.slice;
    var args = slice.call(arguments, 1);

    return function() {
      return fn.apply(this, args.concat(slice.call(arguments, 0)));
    };
  }

  function compose() {
    var funcs = Array.prototype.slice.call(arguments).reverse();

    return function() {
      return funcs.slice(1).reduce(function(res, fn) {
        return fn(res);
      }, funcs[0].apply(undefined, arguments));
    };
  }

  /* Support */

  function getSupport() {
    return {
      IntersectionObserver:
        'IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype,
      CSSAnimation: 'animation' in document.body.style,
      pushState: window.history && window.history.pushState,
      customProperties: window.CSS && CSS.supports('color', 'var(--primary)'),
      scrollBehavior: 'scrollBehavior' in document.body.style
    };
  }

  /* Theme editor */

  function themeEditor() {
    document.addEventListener('shopify:block:select', function(evt) {
      if (publicAPI && config.blocks && typeof config.blocks[evt.detail.blockId] !== 'undefined') {
        publicAPI.goTo(config.blocks[evt.detail.blockId]);
      }
    });

    document.addEventListener('shopify:section:load', function() {
      var track = document.querySelector('.quiz-track');
      if (track) track.style.scrollBehavior = 'initial';
      init();
    });
  }
})();